import * as React from 'react';
import { EProjectType } from '../../../enum/project';
import { IProjectInfoForm } from '../../../pages/ProjectInfo/IProjectInfo';
import arial from '../../../style/Arial/arial.ttf';
import { IProjectMacra2 } from '../../../MACRA_2/store/project/projectSlice';
import PDFSloped from './PDFSloped';
import PDFStepped from './PDFStepped';
import PDFVertical from './PDFVertical';
import { ISlopedGabionResults, ISteppedGabionResults, IVerticalDropsResults } from '../../../MACRA_2/api/IApiResponse';
import { Document, Font, Image, Page, Text, View } from '@react-pdf/renderer';
import PDFHeader from '../PDFLayout/PDFHeader';
import PDFFooter from '../PDFLayout/PDFFooter';
import ProjectInformation from '../PDFComponents/ProjectInformation';
import { styles } from '../../../components/PDF/PDFStyle';
import { useTranslation } from 'react-i18next';
import { height } from '@mui/system';

interface IPDFMacra2Props {
    project: IProjectMacra2;
    projectInfo: IProjectInfoForm;
    results: ISteppedGabionResults | ISlopedGabionResults | IVerticalDropsResults;
    channelDesignImg: string;
    dischargeCurveImg: string;
}

Font.register({
    family: 'Arial',
    fonts: [
        {
            src: arial,
        },
    ],
});

const PDFMacra2: React.FunctionComponent<IPDFMacra2Props> = props => {
    const { t } = useTranslation();
    const { project, projectInfo, results, channelDesignImg, dischargeCurveImg } = props;

    let component: JSX.Element;

    switch (projectInfo.type) {
        case EProjectType.Macra2 | EProjectType.VerticalDrop:
            component = <PDFVertical project={project} projectInfo={projectInfo} results={results as IVerticalDropsResults} />;
            break;
        case EProjectType.Macra2 | EProjectType.SlopedWeir:
            component = <PDFSloped project={project} projectInfo={projectInfo} results={results as ISlopedGabionResults} />;
            break;
        case EProjectType.Macra2 | EProjectType.SteppedWeir:
            component = <PDFStepped project={project} projectInfo={projectInfo} results={results as ISteppedGabionResults} />;
            break;
        default:
            component = <></>;
            break;
    }

    return (
        <Document>
            <Page size='A4' orientation='landscape' style={styles.page}>
                <PDFHeader projectInfo={projectInfo} />
                <View style={styles.body}>
                    <View>
                        <ProjectInformation projectInfo={projectInfo} />
                    </View>
                    <View>
                        <Text style={styles.boldGreen}>{t('graphical_results_channel_design')}</Text>
                        <View style={{ ...styles.box, height: '280px' }}>{!!channelDesignImg && <Image src={channelDesignImg} />}</View>
                    </View>

                    <View break>{component}</View>

                    <Text style={styles.boldGreen} break>
                        {t('graphical_results_cross_section')}
                    </Text>
                    <View style={{ ...styles.box, height: '280px' }}>{!!dischargeCurveImg && <Image src={dischargeCurveImg} />}</View>
                    <View style={styles.disclaimerBox}>
                        <View style={styles.disclaimerTitleBox}>
                            <View style={styles.greenRectangleDisclaimer}></View> <Text style={{ paddingLeft: '3px' }}>{t('pdf_disclaimer')}</Text>
                        </View>
                        <Text>{t('pdf_disclaimer_body')}</Text>
                    </View>
                </View>
                <PDFFooter />
            </Page>
        </Document>
    );
};

export default PDFMacra2;
